import { useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useForm } from "react-hook-form";
import { addList } from '../../service/api';
import { NewListContainer } from './stylesCreateNewList';
import { auth } from "../../service";


const model: string[] = [];
export default function CreateNewList() {
    const user = auth.currentUser;
    
    //Bootstrap modal hooks
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    //New List
    const [listName, setListName] = useState("");
    const [currentProduct, setCurrentProduct] = useState("");
    const [productArray, setProductArray] = useState(model);

    function addProductToArray() {
        setProductArray([
            ...productArray,
            currentProduct
        ]);
    }

    function createNewList() {
        addList({
            title: listName, items: (productArray.map((item: string) => {
                return { name: item, checked: false, price: 0, quantities: 0, unities: 0 }
            })), completed: false, user_id: (user?.uid !== null ? user?.uid : " ")
        });
        handleClose();
        setProductArray(model);
        setListName("")
        setCurrentProduct("")
        alert("Lista adicionada com sucesso!")
    }

    return (
        <>
            <Button variant="success" onClick={(handleShow)} >Criar nova lista</Button>



            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Crie uma nova lista de compras:</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <NewListContainer>
                        <input type="text" placeholder="Insira o nome da lista: " onChange={e => setListName(e.target.value)} />

                        <input type="text" value={currentProduct} onChange={(e) => setCurrentProduct(e.target.value)} placeholder="Insira o produto desejado na lista: " />
                        <Button onClick={() => {
                            addProductToArray();
                            setCurrentProduct("");
                            }}>Adicionar Produto na lista</Button>
                        <label>Lista: </label>
                        <ul>
                            {productArray.length > 0 && productArray.map((item: string) => {
                                return (
                                    <div>
                                        <li>{item}</li>
                                        {item && <button onClick={() => {
                                            productArray[(productArray.indexOf(item))] = "";
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
                                                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                            </svg>
                                        </button>}
                                    </div>
                                );
                            })}
                        </ul>
                    </NewListContainer>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Fechar
                    </Button>
                    <Button onClick={() => createNewList()} variant="primary" >Salvar Nova Lista</Button>
                </Modal.Footer>
            </Modal>

        </>
    );
}